<template>
  <div class="item">
    <el-image :src="data.image"></el-image>
    <div class="info">
      <div class="title">{{ data.title }}</div>
      <div class="desc">{{ data.desc }}</div>
      <div class="time-btn">
        <div class="time">{{ data.updateTime }}</div>
        <div class="btn" @click="$router.push(`/news/detail?newsId=${data.newsId}`)">
          <span>查看详情</span>
          <i class="el-icon-arrow-right"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NewsItem",
  props: {
    data: Object
  }
}
</script>

<style scoped lang="scss">
.item {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 20px;
  background-color: #FFFFFF;
  border-radius: 8px;
  border: 2px solid transparent;

  &:last-child {
    margin-bottom: 0;
  }

  &:hover {
    border: 2px solid #1464FF;
  }

  .el-image {
    width: 320px;
    height: 240px;
  }

  .info {
    flex: 1;
    width: 0;
    height: 240px;
    margin-left: 25px;
    display: flex;
    flex-direction: column;
    justify-content: center;

    .title {
      font-size: 24px;
      font-weight: bold;
      color: #2D2D2D;
      margin-bottom: 0;
    }

    .desc {
      font-size: 15px;
      color: #6C6C6C;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 4;
      overflow: hidden;
      text-overflow: ellipsis;
      margin: 20px 0;
      text-indent: 2ch;
    }

    .time-btn {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      font-size: 14px;
      font-weight: bold;
      color: #6C6C6C;

      .btn {
        cursor: pointer;

        &:hover {
          text-decoration: underline;
        }
      }
    }
  }
}
</style>